// React
import React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

// UTILS
import { toArray } from 'utils/lodashUtils';

// VENDOR UTILS
import { withRouter } from 'react-router-dom';
const moment = require('moment-timezone');

// VENDOR COMPONENTS
import CircularProgress from 'material-ui/CircularProgress';
import { List } from 'material-ui/List';
import SwipeableViews from 'react-swipeable-views';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

// COMPONENTS
import { Hero } from 'components/Hero';
import { Content } from 'components/Content/Content';
import { FluidSection } from 'components/FluidSection/FluidSection';
import ServiceProgress from 'components/ServiceCardList/ServiceProgress';
import ServiceDate from 'components/ServiceCardList/ServiceDate';
import H1 from 'components/Primatives/H1';
import PText from 'components/Primatives/PText';
import DropShadow from 'components/Primatives/DropShadow';
import FlexColumn from 'components/Primatives/FlexColumn';
import FlexRow from 'components/Primatives/FlexRow';
import BackgroundImg from 'components/Primatives/BackgroundImg';
import Strong from 'components/TextModifiers/Strong';
import StyledRouteLink from 'components/Assests/StyledRouteLink';
import GlobalMaxWidth from 'components/Assests/GlobalMaxWidth';
import ServiceModulesBreadcrumbs from './ServiceModulesBreadcrumbs';

// INTERACTION COMPONENTS
import ClientBookingModule from 'components/Booking/ClientBookingModule';
import InteractionPanel from 'components/InteractionComponents/InteractionPanel';
import ServiceDashboard from './ServiceDashboard';

// UTILS
import { constants } from '../../constants';

class ServiceModules extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            booking: null,
            company: null,
            height: 0,
            gotThread: false,
            provider: null,
            service: null,
            viewIndex: 0,
            width: 0,
        };
    }

    componentWillMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        this.props.getDBProviders();
        this.props.getDBServices();
        this.props.getDBProviderCompanies();
        this.props.getDBServiceCategories();
        this.props.getDBServiceModules();
        // this.props.updateLocation(this.props.location.pathname); // what is this?
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    componentDidMount() {
        if (this.props.userId) {
            if (this.state.service && this.state.service._id) {
                this.props.loadUpcomingDbBookings({
                    userId: this.props.userId,
                    serviceId: this.state.service._id,
                    // clientUid,
                    userType: 'client',
                });
            }

            this.props.getClientData(this.props.userId); // TEST
            // Go to the top of the page on load
            document.getElementById('top').scrollIntoView();

            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions);

            this.getProviderCompanyService(this.props);

            if (this.props.match.params.confirmation === 'awaiting') {
                this.props.awaitNewBooking();
                // REFRESH CLIENT DATA THEN USE THAT DATA TO GET NEW SERVICES OWNED BY CLIENT AND FILTER THEM BY STATUS
                this.props.getClientData(this.props.userId, () => {
                    // console.log('GETTING FILTERSERVICE BY STATUS ANY ACTIVE PERIOD SETTING OR PENDING?');
                    this.props.clearServiceStatuses();
                    this.props.filterServicesByStatus(this.props.userData);
                });
            }
        }
        if (!this.props.userId && !this.props.loginDialogOpen) {
            // this.props.openLoginDialog();

            setTimeout(() => {
                if (
                    !this.props.userId &&
                    !this.props.userData &&
                    !this.props.loginDialogOpen
                )
                    this.props.openLoginDialog();
            }, 2500);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.service !== this.state.service) {
            this.props.loadUpcomingDbBookings({
                userId: this.props.userId,
                serviceId: this.state.service._id,
                // clientUid,
                userType: 'client',
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userId) {
            // Get the list of services again once new props with more services are received
            if (
                this.props.services &&
                this.props.services.length !== nextProps.services.length
            ) {
                this.props.getDBServices();
            }

            this.getProviderCompanyService(nextProps);
            if (this.props.reduxLocation !== nextProps.reduxLocation) {
                // console.log('LOCATION HAS CHANGED - UPDATING GLOBAL LOCATION STATE');
                this.props.updateLocation(nextProps.location.pathname);
            }
            if (
                nextProps.userData &&
                !nextProps.channel &&
                this.state.service
            ) {
                if (!this.state.gotThread) {
                    this.setState(
                        {
                            gotThread: true,
                        },
                        () => {
                            // console.log('GETTING THREAD AT CWRP OF SERVICE MODULES');
                            this.props.getMessageThread(
                                nextProps.userData,
                                this.state.service,
                                () => {
                                    return null;
                                },
                            );
                        },
                    );
                }
            }
            if (
                this.props.awaitingBooking !== false &&
                nextProps.awaitingBooking === false
            ) {
                // REMOVE THE "AWAITING" URL TRIGGER
                this.props.loadUpcomingDbBookings({
                    userId: this.props.userId,
                    serviceId: this.state.service && this.state.service._id,
                    // clientUid,
                    userType: 'client',
                });
                this.props.history.push(
                    `/service/modules/${this.state.service._id}`,
                );
                this.props.updateLocation(
                    `/service/modules/${this.state.service._id}`,
                );
            }
        }
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
        this.props.updateWindowDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };

    handleChangeViewIndex = index => {
        if (index) {
            this.setState({
                viewIndex: index,
            });
        }
    };

    getProviderCompanyService = props => {
        const { companies, dbProviders, services, match } = props;

        if (dbProviders && services && companies) {
            // console.log(`%cdbPROVIDERS OBJECT SHOULD BE ARRAY${JSON.stringify(props.dbProviders)}`,'color: greenyellow');
            return dbProviders.map(provider => {
                // console.log(`%c${JSON.stringify(provider.uid)} ${JSON.stringify(props.match.params.id)}`,'color: deeppink');
                return services.map(service => {
                    if (service._id === match.params.id) {
                        return companies.map(company => {
                            if (company._id === service.company) {
                                if (provider.uid === service.provider) {
                                    // console.log('MATCH FOUND FOR PROVIDER');
                                    // console.log(provider, company, service, 'PROCOMSER PRESENT?');
                                    this.setState({
                                        provider,
                                        service,
                                        company,
                                    });
                                }
                            }
                        });
                    }
                });
            });
        } else {
            return null;
        }
    };

    handleBackToServiceList = () => {
        this.props.history.push(`/my-services`);
        this.props.updateLocation(`/my-services`);
    };

    render() {
        const { provider, service, company } = this.state;
        const {
            pendingServices,
            inactiveServices,
            activeServices,
            cancelledServices,
        } = this.props.filteredServices;
        // console.log('fdgdfg', service, provider, company, this.props.emailIsVerified, this.props.emailVerified);
        if (this.props.loginDialogOpen && this.props.userId)
            this.props.closeLoginDialog();

        const getServiceActivePeriods = () => {
            const curentService = service;
            let filteredServicesArray = toArray(this.props.filteredServices);
            let activePeriods = [];
            filteredServicesArray = filteredServicesArray.filter(
                clean => clean,
            );

            if (filteredServicesArray && filteredServicesArray.length > 0) {
                filteredServicesArray.map(activeState => {
                    if (activeState.length > 0) {
                        return activeState.map(serviceItem => {
                            if (serviceItem._id === curentService._id) {
                                return (activePeriods =
                                    serviceItem.activePeriods);
                            }
                        });
                    }
                });
            }
            return activePeriods;
        };
        // console.log('SM-this.state.service',  this.state.service)
        // console.log('SM-this.state',  this.state)
        // console.log('SM-this.props.reduxLocation',  this.props.reduxLocation)
        // console.log('SM-this.props.channel',  this.props.channel)
        // console.log(
        //     'fdgdfg',
        //     service,
        //     provider,
        //     company,
        //     this.props.emailIsVerified,
        //     this.props.emailVerified,
        // );
        if (
            this.props.userId &&
            (this.props.emailIsVerified || this.props.emailVerified)
        ) {
            // console.log('fdgdfg', service, provider, company);
            return (
                <div
                    id="ServiceModulesOuterContainer"
                    style={{
                        alignitems: 'center',
                        display: 'flex',
                        placeContent: 'center',
                    }}
                >
                    {service && service.coverPhotoURL && (
                        <div
                            id="ServiceModulesInnerContainer"
                            style={styles.innerContainerDesktopStyles}
                        >
                            {this.state.width >=
                                constants.layout.breakpoint.break1 && (
                                <React.Fragment>
                                    <ServiceModulesBreadcrumbs />
                                    <div
                                        id="page-section"
                                        style={styles.pageSectionStyles}
                                    >
                                        {this.props.dbProviders &&
                                            this.props.userData &&
                                            this.props.filteredServices && (
                                                <ServiceDashboard
                                                    userData={
                                                        this.props.userData
                                                    }
                                                    service={service}
                                                    provider={provider}
                                                    reduxLocation={
                                                        this.props.reduxLocation
                                                    }
                                                    activePeriods={getServiceActivePeriods()}
                                                />
                                            )}
                                        {provider && service && company && (
                                            <InteractionPanel
                                                selectedService={service}
                                                service={service}
                                                company={company}
                                                provider={provider}
                                                location={
                                                    this.props.reduxLocation
                                                }
                                                channel={this.props.channel}
                                                shouldHideBookingTab
                                            />
                                        )}
                                    </div>
                                </React.Fragment>
                            )}
                            {this.state.width <
                                constants.layout.breakpoint.break1 &&
                                provider &&
                                service &&
                                company && (
                                    <InteractionPanel
                                        selectedProvider={
                                            this.state.selectedProviderData
                                        }
                                        serviceId={
                                            this.props.match &&
                                            this.props.match.params &&
                                            this.props.match.params.id
                                                ? this.props.match.params.id
                                                : null
                                        }
                                        selectedService={this.state.service}
                                        reduxLocation={this.props.reduxLocation}
                                        onReturnClick={
                                            this.handleBackToServiceList
                                        }
                                        service={service}
                                        company={company}
                                        provider={provider}
                                        // width={this.state.width}
                                        channel={this.props.channel}
                                    />
                                )}
                        </div>
                    )}
                </div>
            );
        }
        return null;
    }
}

const mapStateToProps = ({
    provider,
    service,
    company,
    auth,
    client,
    booking,
    router,
    chat,
}) => {
    // console.log(`%cROUTER: ${JSON.stringify(router)}`,'color: aqua');
    // console.log('CURRENT COMMUNICATION THREAD', chat.messageThread);

    return {
        loginDialogOpen: auth.loginDialogOpen,
        channel: chat.messageThread,
        reduxLocation: router.location,
        userData: client.clientData,
        userId: auth.authData ? auth.authData.id : null,
        emailIsVerified: auth.verificationStatus,
        emailVerified: auth.authData.emailVerified,
        dbProviders: provider.providers,
        services: service.services,
        serviceCategories: service.categories,
        serviceModules: service.modules,
        companies: company.providerCompanies,
        sbmProvider: booking.provider,
        awaitingBooking: booking.awaitingBooking,
        filteredServices: {
            inactiveServices: service.inactiveServices,
            pendingServices: service.pendingServices,
            activeServices: service.activeServices,
            cancelledServices: service.cancelledServices,
        },
    };
};

// const mapDispatchToProps = () => {

// };

export default withRouter(
    connect(
        mapStateToProps,
        actions,
    )(ServiceModules),
);

const styles = {
    innerContainerDesktopStyles: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        // height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 73px)' /* REMOVES BOTTOM GAP */,
        padding: 0,
    },
    pageSectionStyles: {
        ...constants.layout.contentWidth,
        // height: 'calc(100vh - 73px)', /* REMOVES BOTTOM GAP */
        display: 'flex',
        flex: 1,
        flexFlow: 'row nowrap',
        alignItems: 'stretch',
        overflow: 'hidden',
    },
};



// WEBPACK FOOTER //
// ./src/js/containers/ServiceContainer/ServiceModules.jsx